interface CurrencyProps {
  value: number;
  currency?: string;
  decimalPlaces?: number;
}

export default function Currency({
  value,
  currency = "BRL",
  decimalPlaces = 2,
}: CurrencyProps) {
  const formatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency,
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });

  return (
    <span className="font-light text-primary-900 dark:text-white">
      {formatter.format(value)}
    </span>
  );
}
